import { TTheme } from '@/core/theme'
import { getStatusColors } from '@/ui/components/IssueStatus/utils'
import { styled } from '@mui/system'

export const StyledIssueStatus = styled('div')<{
    status: TIssueStatus
    theme?: TTheme
}>`
    display: inline-flex;
    align-items: center;
    height: 24px;
    padding: 0 10px;
    box-sizing: border-box;
    border-radius: 4px;
    background-color: ${({ status, theme }) =>
        getStatusColors(status, theme).background};
    color: ${({ status, theme }) => getStatusColors(status, theme).color};
    border: 1px solid ${({ status, theme }) =>
        getStatusColors(status, theme).border};
`
